export const GET_REDIRECT_BILLING_HISTORY_REQUEST = "GET_REDIRECT_BILLING_HISTORY_REQUEST";
export const GET_REDIRECT_BILLING_HISTORY_SUCCESS = "GET_REDIRECT_BILLING_HISTORY_SUCCESS";
export const GET_REDIRECT_BILLING_HISTORY_FAIL = "GET_REDIRECT_BILLING_HISTORY_FAIL";